import { Box, VStack, Image } from '@telescope/cassini-ui';
import { useWidget } from '@telescope/cassini-hooks';
import { Text, Heading } from 'components';
import { usePrizes } from 'features';
import { Outlet } from 'react-router-dom';
import { APP_MAX_WIDTH } from 'utils';
import { useEffect } from 'react';
import { Open } from 'generated-types/widget';

export const AuthLayout = () => {
  const { data } = useWidget({ select: (data: Open) =>  data.widget.global_views.auth });
  const { settings: { isUnavailablePrizesMessageEnabled }, content: { heading, unavailablePrizesMessage } } = data!

  const { refetchAvailablePrizes, hasAvailablePrize } = usePrizes();

  useEffect(() => {
    refetchAvailablePrizes();
  }, [refetchAvailablePrizes])

  return (
    <Box maxW={{ lg: APP_MAX_WIDTH.TABLET }} mx="auto" w="100%">
      <VStack spacing={6} mb={12}>
        <Image src={heading.image} alt={heading.alt} w="100%"/>
        <Heading as="h1" fontSize={{base: '4xl', lg: '5xl'}} textAlign="center" allowMarkdown>
          {heading.copy}
        </Heading>
      </VStack>

      <Outlet />

      { isUnavailablePrizesMessageEnabled && hasAvailablePrize === false &&
        <Text align="center" mt={12} mb={3}> {unavailablePrizesMessage} </Text> }
    </Box>
  )
}